import React, { useState } from "react";
import classes from "./Login.module.css";
import bigcirlce from "../../Assets/bigcircle.svg";
import smallcirlce from "../../Assets/smallcircle.svg";
import promix from "../../Assets/Promix.svg";
import authimg from "../../Assets/authimg.png";
import cal from "../../Assets/calculate.svg";
import accend from "../../Assets/accend.svg";
import corporate from "../../Assets/corporate.svg";
import smallsquare from "../../Assets/smallsquare.svg";
import bigsquare from "../../Assets/bigsquare.svg";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg"
import { Link } from "react-router-dom";
import axios from 'axios';
import { BASE_URL } from '../../Components/API/Api';
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';
import { useNavigate, useSearchParams } from "react-router-dom";


const Login = () => {
  const { login, updateUser, user } = useUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [showCompanySelector, setShowCompanySelector] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const navigate = useNavigate();

  const handleCompanyChange = (val) => {
    setSelectedCompanyId(String(val));
    const sel = companies.find((c) => String(c?.id) === String(val) || String(c?.company_id) === String(val) || String(c?.companyId) === String(val));
    if (sel) {
      localStorage.setItem('companyInfo', JSON.stringify(sel));
      // update the user context so dashboard reads the selected company
      try {
        // set axios default header immediately so requests are scoped
        axios.defaults.headers.common['company_id'] = String(val);
      } catch (e) {}
      if (typeof updateUser === 'function') {
        const newUser = user ? { ...user, company: sel, company_id: String(val) } : { company: sel, company_id: String(val) };
        updateUser(newUser);
      }
    }
    localStorage.setItem('company_id', String(val));
  };


  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire('Error', 'Email and password are required', 'error');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/v1/login`, {
        email,
        password,
      });
      const apiData = response.data?.data || {};
      const token = apiData?.token;
      // user object is provided under data.user in the API response
      const userObj = apiData.user || { name: apiData.name || 'User', email };
      // const email = response.data?.data?.user?.email;
      // console.log(response.data?.data?.user?.email);  
      localStorage.setItem('userObj', JSON.stringify(userObj));

      if (!token) {
        throw new Error("Token not returned from server.");
      }

      // persist auth and user
      login(userObj, token);

      // include main company (from user.company), top-level company_name, and any additional companies
      const companiesFromApi = Array.isArray(apiData.companies) ? apiData.companies : (apiData.companies ? [apiData.companies] : []);
      const mainCompanyObj = apiData.user && apiData.user.company ? apiData.user.company : null;

      // build normalized list with { id, name, ...rest }
      const candidates = [];

      if (mainCompanyObj) {
        candidates.push({
          id: String(mainCompanyObj?.id || mainCompanyObj?.company_id || mainCompanyObj?.companyId || 'main'),
          name: mainCompanyObj?.name || mainCompanyObj?.company_name || apiData.company_name || '',
          ...mainCompanyObj,
        });
      }

      // if API returns top-level company_name and we didn't already add it, include it
      if (apiData.company_name && !candidates.find(c => c.name === apiData.company_name)) {
        candidates.push({ id: 'main_name', name: apiData.company_name });
      }

      companiesFromApi.forEach((c) => {
        if (!c) return;
        const id = String(c?.id || c?.company_id || c?.companyId || Math.random());
        candidates.push({ id, name: c?.name || c?.company_name || '', ...c });
      });

      // dedupe by id then by name
      const mergedMap = new Map();
      candidates.forEach((c) => {
        if (!c) return;
        const key = String(c.id || c.name || Math.random());
        if (!mergedMap.has(key)) mergedMap.set(key, c);
      });

      const merged = Array.from(mergedMap.values());
      setCompanies(merged);
      // persist companies list so header can offer switching without extra API calls
      try { localStorage.setItem('companies', JSON.stringify(merged)); } catch (e) { /* ignore */ }

      if (merged.length === 0) {
        // No company available - continue to dashboard
        navigate('/dashboard');
      } else {
        // At least one company available - present selector so user can pick (preselect first)
        const firstId = merged[0]?.id || '';
        setSelectedCompanyId(String(firstId));
        // persist preselected company so dashboard will use it if user immediately continues
        handleCompanyChange(firstId);
        setShowCompanySelector(true);
      }

    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response?.data);

      // ❌ Error alert
      Swal.fire({
        title: 'Login Failed',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonText: 'Try Again'
      });

    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <div className={classes.main}>
        <div className={classes.leftside}>

          <div className={classes.grit}>
            <img src={promix} className={classes.pro} />
            <p className={classes.fir_txt}>
              <span className={classes.fir_txtRest}>Smart </span>
              <span className={classes.fir_txtAccent}>Accounting</span>
              <span className={classes.fir_txtRest}> for Nigerian Businesses</span>
            </p>
            <p className={classes.sec_txt}>
            Trusted by SMEs across Nigeria to manage their finances smarter
            </p>

            <div>
              <img src={authimg} className={classes.authimgleft} />
            </div>
          </div>
        </div>

        <div className={classes.right}>
          <div className={classes.protw}>
            <p className={classes.cre_top}>Welcome Back</p>
            <p className={classes.adkt}>Sign in to your account to </p>
          </div>

          <div className={classes.portned} onKeyDown={(e) => e.key === "Enter" && handleLogin()}>
            <div className={classes.coprte}>
              <label>Email Address</label>
              <input
                type="text"
                placeholder="Enter your email"
                className={classes.print}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={classes.james}>
              <label>Password</label>
              <div className={classes.portal}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Create a strong password"
                  className={classes.print}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <img
                  src={showPassword ? eyesoff : eye}
                  alt="Toggle visibility"
                  className={classes.eye}
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>

          </div>

          {showCompanySelector && (
            <div className={classes.companySelectWrap}>
              <label className={classes.companySelectLabel}>Select company to continue</label>
              <select
                value={selectedCompanyId}
                onChange={(e) => handleCompanyChange(e.target.value)}
                className={classes.companySelect}
              >
                <option value="">Choose company...</option>
                {companies.map((c, idx) => {
                  const id = c?.id || c?.company_id || c?.companyId || idx;
                  return (
                    <option key={id} value={id}>
                      {c.name || ''}
                    </option>
                  );
                })}
              </select>
              <div style={{ marginTop: 12 }}>
                <button
                  className={classes.sign}
                  onClick={() => {
                    if (!selectedCompanyId) {
                      return Swal.fire('Select company', 'Please select a company to continue', 'warning');
                    }
                    const sel = companies.find((c) => String(c?.id || c?.company_id || c?.companyId) === String(selectedCompanyId));
                    if (sel) {
                      const chosenId = sel?.id || sel?.company_id || sel?.companyId || selectedCompanyId;
                      localStorage.setItem('companyInfo', JSON.stringify(sel));
                      localStorage.setItem('company_id', String(chosenId));
                      try { axios.defaults.headers.common['company_id'] = String(chosenId); } catch (e) {}
                    }
                    navigate('/dashboard');
                    // setTimeout(() => window.location.reload(), 120);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}

          <div className={classes.joshe}>
            <div className={classes.pintoe}>
              <input type="checkbox" className={classes.shipet} />
              <p className={classes.abode}>Remember me</p>
            </div>

            <div>
              <p
                className={classes.crit}
                onClick={() => navigate("/forgotpassword")}
                style={{ cursor: "pointer" }}
              >
                Forgot password?
              </p>
            </div>
          </div>

          {!showCompanySelector && (
            <button
              className={classes.sign}
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? (
                <span className={classes.spinner}></span>
              ) : (
                'Sign in'
              )}
            </button>
          )}


          <p className={classes.rec}>
            Don't have an account?{" "}
            <Link to="/signup">
              <span className={classes.cptue}>Sign up</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
